import { FormattedMessage, useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import styles from './GridMoreBaseMapsItem.module.scss';
import moreImgSrc from './moreImg.png';

type Props = {
  handleShowMore: () => void;
};

const GridMoreBaseMapsItem = ({ handleShowMore }: Props) => {
  const intl = useIntl();
  return (
    <div
      className={styles.container}
      onClick={handleShowMore}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleShowMore();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <Image className={styles.image} alt={intl.formatMessage({ defaultMessage: 'More' })} src={moreImgSrc} width={105} height={70} />
      <Typography variant="text100" component="div">
        <FormattedMessage defaultMessage="More" />
      </Typography>
    </div>
  );
};

export default GridMoreBaseMapsItem;
